var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 63,
    viewBox: "0 0 80 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.500002 18C0.500002 17.4477 0.947717 17 1.5 17L68.5 17C69.0523 17 69.5 17.4477 69.5 18C69.5 18.5523 69.0523 19 68.5 19L1.5 19C0.947717 19 0.500002 18.5523 0.500002 18Z",
    fill: "#9D9ABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 46C8.5 45.4477 8.94772 45 9.5 45H22.2629C22.8152 45 23.2629 45.4477 23.2629 46C23.2629 46.5523 22.8152 47 22.2629 47H9.5C8.94772 47 8.5 46.5523 8.5 46Z",
    fill: "#9D9ABA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 46C30 45.4477 30.4214 45 30.9412 45H45.0588C45.5786 45 46 45.4477 46 46C46 46.5523 45.5786 47 45.0588 47H30.9412C30.4214 47 30 46.5523 30 46Z",
    fill: "#9D9ABA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70 8.375C70 6.28994 69.1809 4.2881 67.7193 2.81043C66.2574 1.33238 64.2722 0.500003 62.2 0.500003L7.8 0.5C5.72775 0.5 3.74262 1.33238 2.2807 2.81042C0.819147 4.28809 2.14732e-06 6.28994 2.14732e-06 8.375L0 49.625C-9.11409e-08 51.7101 0.819145 53.7119 2.2807 55.1896C3.74261 56.6676 5.72775 57.5 7.8 57.5L47.4373 57.5C48.3711 57.4999 49.2962 57.3305 50.1688 57.001C49.6634 56.4811 49.1919 55.9281 48.758 55.3454C48.3259 55.4478 47.8827 55.4999 47.4371 55.5L7.8 55.5C6.2653 55.5 4.79122 54.8837 3.70264 53.7831C2.6137 52.6822 2 51.1867 2 49.625L2 8.375C2 6.81334 2.6137 5.31781 3.70265 4.21686C4.79122 3.11628 6.26531 2.5 7.8 2.5L62.2 2.5C63.7347 2.5 65.2088 3.11628 66.2974 4.21686C67.3863 5.31781 68 6.81334 68 8.375V30.1248C68.6905 30.3945 69.3584 30.7093 70 31.0657V8.375Z",
    fill: "#9D9ABA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 30C53.4396 30 46.5 36.9396 46.5 45.5C46.5 54.0604 53.4396 61 62 61C70.5604 61 77.5 54.0604 77.5 45.5C77.5 36.9396 70.5604 30 62 30ZM44.5 45.5C44.5 35.835 52.335 28 62 28C71.665 28 79.5 35.835 79.5 45.5C79.5 55.165 71.665 63 62 63C52.335 63 44.5 55.165 44.5 45.5Z",
    fill: "#9D9ABA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3009 39.5878C71.6914 39.9783 71.6914 40.6115 71.3009 41.002L61.4014 50.9015C61.0108 51.2921 60.3777 51.2921 59.9872 50.9015C59.5966 50.511 59.5966 49.8778 59.9872 49.4873L69.8866 39.5878C70.2772 39.1973 70.9103 39.1973 71.3009 39.5878Z",
    fill: "#9D9ABA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7929 43.2929C54.1834 42.9024 54.8166 42.9024 55.2071 43.2929L61.4014 49.4872C61.7919 49.8777 61.7919 50.511 61.4014 50.9015C61.0108 51.2921 60.3777 51.2921 59.9872 50.9015L53.7929 44.7071C53.4024 44.3166 53.4024 43.6834 53.7929 43.2929Z",
    fill: "#9D9ABA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/payment-success.747c1f1e.svg";
export { ForwardRef as ReactComponent };